import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMemberWithdrawalRequests, fetchSavingsWithdrawalRequests } from "../../store/actions/adminActions";


export function useWithdrawalRequests(type) {
    const dispatch = useDispatch();
    const admin = useSelector((state) => state.admin);

    const [filterStatus, setFilterStatus] = useState("pending");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const withdrawalRequests = type === "savings"
        ? admin.savingsWithdrawalRequests
        : admin.memberWithdrawalRequests;

    const isLoading = admin.isLoading;
    const pagination = admin.pagination;

    useEffect(() => {
        const fetchAction = type === "savings"
            ? fetchSavingsWithdrawalRequests
            : fetchMemberWithdrawalRequests;

        dispatch(fetchAction({
            page: currentPage,
            status: filterStatus === "all" ? undefined : filterStatus,
            search: searchQuery || undefined
        }));
    }, [dispatch, type, filterStatus, searchQuery, currentPage]);

    const handleFilterChange = (status) => {
        setFilterStatus(status);
        setCurrentPage(1);
    };

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const resetFilters = () => {
        setFilterStatus("pending");
        setSearchQuery("");
        setCurrentPage(1);
    };

    return {
        withdrawalRequests,
        isLoading,
        pagination,
        filterStatus,
        searchQuery,
        currentPage,
        setSearchQuery,
        handleFilterChange,
        handleSearch,
        handlePageChange,
        resetFilters
    };
}
